module.exports = __webpack_public_path__ + "img/bagels_cooking.a9146d45.jpg";